

import { Box, DashboardModule, SidebarModalListItem } from '@domain-group/suit-theme'

import type { TemplatePageModel } from '@models/types'

interface TemplatePageDetailsProps {
  templatePage: Partial<TemplatePageModel>,
}

const TemplatePageDetails = (props: TemplatePageDetailsProps) => {
  const { templatePage } = props
  const { id, title } = templatePage

  return (
    <DashboardModule title="Selected Templates">
      <Box flexDirection="column" paddingX="large">
          <Box marginTop="medium">
            <SidebarModalListItem title={title ?? 'Loading...'} secondaryText={`Template Page ID #${id ?? '...'}`} />
          </Box>
      </Box>
    </DashboardModule>
  )
}

export default TemplatePageDetails
